// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/myOrganisations/myOrganisationsActions";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../../../_metronic/_helpers";
import * as uiHelpers from "../MyOrganisationsUIHelpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useMyOrganisationsUIContext } from "../MyOrganisationsUIContext";

export const MyOrganisationsTable = () => {
  const myOrganisationsUIContext = useMyOrganisationsUIContext();
  const myOrganisationsUIProps = useMemo(() => {
    return {
      queryParams: myOrganisationsUIContext.queryParams,
      setQueryParams: myOrganisationsUIContext.setQueryParams,
    };
  }, [myOrganisationsUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.myOrganisations }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchMyOrganisations(myOrganisationsUIProps.queryParams));
  }, [myOrganisationsUIProps.queryParams, dispatch]);

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    }, {
      dataField: "name",
      text: "Название организации",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    }, {
      dataField: "inn",
      text: "ИНН",
    }, {
      dataField: "post",
      text: "Должность",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,

    }
  ];

  // Table pagination properties
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Показывать строки с {from} по {to} из {size}
    </span>
  );

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: myOrganisationsUIProps.queryParams.pageSize,
    page: myOrganisationsUIProps.queryParams.pageNumber,
    paginationTotalRenderer: customTotal,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  myOrganisationsUIProps.setQueryParams
                )}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
